<template>
    <div v-if="isReady">
        <div class="selections" :class="'option-' + locationSelectionType">
            <div class="radio" role="radiogroup" :aria-labelledby="labeledBy">
                <label
                    ><input
                        type="radio"
                        name="selectionType"
                        v-model="locationSelectionType"
                        value="single"
                    />Single&nbsp;Location</label
                >
                <label
                    ><input
                        type="radio"
                        name="selectionType"
                        v-model="locationSelectionType"
                        value="combine"
                    />Combine&nbsp;Locations</label
                >
                <label
                    ><input
                        type="radio"
                        name="selectionType"
                        v-model="locationSelectionType"
                        value="compare"
                    />Compare&nbsp;Locations</label
                >
            </div>
            <div class="sub-selections">
                <div>
                    <select
                        id="surveyLocation"
                        v-if="locationSelectionType === 'single'"
                        v-model="selectedLocation"
                        v-focus
                        v-on:change="updateStore()"
                        aria-label="Location"
                    >
                        <option value="-1">Select Location</option>
                        <option value="0">All</option>
                        <option
                            v-for="location in statesForSelection"
                            v-bind:value="location.location.stateId"
                            v-bind:key="location.location.stateId"
                            :disabled="!location.isInAllYears"
                            :title="
                                location.isInAllYears
                                    ? ''
                                    : 'Location is not in all years selected'
                            "
                        >
                            {{ location.location.state }}
                        </option>
                    </select>
                </div>
                <div>
                    <div
                        :class="
                            'selection-box ' +
                            (locationSelectionType === 'combine'
                                ? ''
                                : 'disabled')
                        "
                    >
                        <template v-if="locationSelectionType === 'combine'">
                            <ul class="list-group checked-list-box">
                                <li
                                    v-for="(
                                        location, itemIndex
                                    ) in statesInAnyYearsWithAll"
                                    v-bind:key="'states_' + itemIndex"
                                    class="checkbox"
                                >
                                    <label>
                                        <input
                                            v-if="itemIndex === 0"
                                            type="checkbox"
                                            v-model="selectAllDeselected"
                                            v-on:keydown="
                                                common.navigateCheckboxes(
                                                    $event,
                                                    $refs.items,
                                                    itemIndex
                                                )
                                            "
                                            ref="items"
                                            v-on:change="selectAllStates"
                                        />
                                        <input
                                            v-if="itemIndex !== 0"
                                            type="checkbox"
                                            v-model="selectedLocations"
                                            v-bind:value="location.stateId"
                                            v-on:keydown="
                                                common.navigateCheckboxes(
                                                    $event,
                                                    $refs.items,
                                                    itemIndex
                                                )
                                            "
                                            ref="items"
                                            v-on:change="updateStore()"
                                            :tabindex="-1"
                                        />
                                        {{ location.state }}
                                    </label>
                                </li>
                            </ul>
                        </template>
                    </div>
                </div>
                <div>
                    <div
                        :class="
                            'selection-box ' +
                            (locationSelectionType === 'compare'
                                ? ''
                                : 'hidden-xs disabled')
                        "
                    >
                        <template v-if="locationSelectionType === 'compare'">
                            <ul class="list-group checked-list-box">
                                <li
                                    v-for="(
                                        location, itemIndex
                                    ) in statesInAnyYearsWithAll"
                                    v-bind:key="'states2_' + itemIndex"
                                    class="checkbox"
                                >
                                    <label>
                                        <input
                                            v-if="itemIndex === 0"
                                            type="checkbox"
                                            v-model="selectAllDeselected"
                                            v-on:keydown="
                                                common.navigateCheckboxes(
                                                    $event,
                                                    $refs.items2,
                                                    itemIndex
                                                )
                                            "
                                            ref="items2"
                                            v-on:change="selectAllStates"
                                        />
                                        <input
                                            v-if="itemIndex !== 0"
                                            type="checkbox"
                                            v-model="selectedLocations"
                                            v-bind:value="location.stateId"
                                            v-on:keydown="
                                                common.navigateCheckboxes(
                                                    $event,
                                                    $refs.items2,
                                                    itemIndex
                                                )
                                            "
                                            ref="items2"
                                            v-on:change="updateStore()"
                                            :tabindex="-1"
                                        />
                                        {{ location.state }}
                                    </label>
                                </li>
                            </ul>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import common from '@/scripts/common';
import commonModelHelper from '@/scripts/commonModelHelper';
import store from '@/store';

export default {
    watch: /*no deep*/ {
        locationSelectionType() {
            var vm = this;
            vm.selectedLocation = -1;
            vm.selectedLocations = [];
            vm.selectAllDeselected = false;
            //selectedStates
            vm.updateStore();
        }
    },
    props: ['labeledBy'],
    created: function () {
        const vm = this;
        // console.log('store.state.selModel.selectedLocations', store.state.selModel.selectedLocations);

        vm.statesInAnyYears = commonModelHelper.groupLocations();
        vm.onlyStatesInAllYears = commonModelHelper.groupLocations(true);
        vm.statesForSelection = commonModelHelper.getAllLocationsForSelection();
        vm.statesInAnyYearsWithAll = vm.statesInAnyYears.slice(); //Make a copy of the list
        vm.stateIdsInAnyYears = vm.statesInAnyYears.map((s) => s.stateId);
        vm.statesInAnyYearsWithAll.unshift({
            state: 'All Locations',
            stateId: 0
        });

        vm.isReady = true;
    },
    data: function () {
        let vmData = {
            statesForSelection: null,
            onlyStatesInAllYears: null,
            statesInAnyYears: null,
            stateIdsInAnyYears: null,
            statesInAnyYearsWithAll: null,
            // statesInAllYearsWithAll,
            selectedLocation: -1,
            selectedLocations: [],
            locationSelectionType: null,
            selectAllDeselected: false,
            store,
            common,
            isReady: false
        };
        vmData.locationSelectionType =
            store.state.selModel.locations.selectionType;
        if (!vmData.locationSelectionType)
            vmData.locationSelectionType = 'single';
        if (store.state.selModel.locations.ids.length > 0) {
            vmData.selectedLocation = store.state.selModel.locations.ids[0];
            vmData.selectedLocations = store.state.selModel.locations.ids;
        }
        return vmData;
    },
    methods: {
        updateStore() {
            var vm = this;
            //TODO:
            store.dispatch('selModel/setLocations', {
                selectionType: vm.locationSelectionType,
                locationIds:
                    vm.locationSelectionType === 'single'
                        ? [vm.selectedLocation]
                        : vm.selectedLocations
            });
            store.dispatch('selModel/setReadyForNextStep');
        },
        selectAllStates: function () {
            var vm = this;
            if (vm.selectAllDeselected)
                vm.selectedLocations = vm.stateIdsInAnyYears;
            else vm.selectedLocations = [];
            vm.updateStore();
        }
    }
};
</script>

<style scoped="">
/* @media only screen and (min-width: 1280px) {} */
@media only screen and (min-width: 992px) {
    .selections .radio {
        display: flex;
        flex-direction: row;
    }
    .selections .radio label {
        width: 33%;
    }

    .selections .sub-selections {
        display: flex;
        flex-direction: row;
    }
    .selections .sub-selections > div {
        width: 33%;
        /* padding: 0px 5px 0px 10px; */
        /* box-sizing: content-box; */
    }
    .selections .selection-box,
    .selections select {
        margin-left: 13%;
    }
}

@media only screen and (max-width: 991px) {
    .selections .radio label {
        width: 100%;
        height: 40px;
        display: block;
    }
    .option-single .radio label:nth-child(2) {
        margin-top: 30px;
    }

    /* .selections .sub-selections div:first-child select {
          
  } */

    .sub-selections > div {
        display: none;
    }
    .option-single .sub-selections div:first-child {
        display: block;
        margin-top: -134px;
        margin-bottom: 104px;
        height: 30px;
        z-index: 1;
        position: relative;
        margin-left: 40px;
    }

    .option-combine .radio label:nth-child(3) {
        margin-top: 230px;
    }

    .option-combine .sub-selections div:nth-child(2) {
        display: block;
        margin-top: -290px;
        margin-bottom: 40px;
        height: 250px;
        z-index: 1;
        position: relative;
        margin-left: 40px;
    }

    .option-compare .sub-selections div:nth-child(3) {
        display: block;
        margin-left: 40px;
        margin-top: -20px;
        margin-bottom: 20px;
    }
    /* .selections .radio {
    display: flex;
    flex-direction: column;
  }
  .selections .selection-box {
     margin-left: 15px;
     position: absolute; 
     transform: translate(-10px, 30px);
  } */
}
@media only screen and (max-width: 280px) {
    div.selections > div.sub-selections > div {
        margin-left: 0px !important;
    }
}
.selection-box {
    padding: 0 0 0 0;
}

.selection-box {
    height: 230px;
    width: 190px;
    overflow-y: auto;
    margin-bottom: 20px;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
}

/* @media only screen and (max-width: 767px) {} */

.spaced-out {
    margin-top: 20px;
    margin-bottom: 20px;
}

ul {
    margin-left: 0px;
}

.refresh-button {
    margin-top: 10px;
}

.disabled {
    background-color: #f5f5f5;
}

.radio {
    padding-left: 0;
}

option:disabled {
    background-color: #f5f5f5;
}
.checkbox,
.radio {
    position: relative;
    display: block;
    margin-top: 10px;
    margin-bottom: 10px;
}
</style>
